import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useSWRInfinite from "swr/infinite";
import axios from "utils/axios";
const PAGE_SIZE = 10;

export default function InfiniteLoader({
  t,
  session: { token = undefined } = {},
  url = "/api/works",
  link = "/works/:id",
  dataKey,
  getData,
  children = () => {},
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const PAGE_SIZE = 10;

  const fetcher = async (url, options) => {
    const data = axios.get(url, options).then((res) => {
      return (
        res?.data?._embedded?.[dataKey] ||
        res?.data?.[dataKey] ||
        res?.data?.data?.[dataKey] ||
        []
      );
    });
    return await data;
  };

  const getKey = (page, previousPageData) => {
    if (!previousPageData || previousPageData?.length === PAGE_SIZE) {
      return {
        url,
        options: {
          params: { page, size: PAGE_SIZE },
        },
      };
    } else {
      if (previousPageData !== null) return null;
    }
  };

  const swr = useSWRInfinite(getKey, ({ url, options }) =>
    fetcher(url, options)
  );
  function NoData() {
    return (
      <Typography sx={{ color: "grey.200", fontSize: 14 }}>no-data</Typography>
    );
  }

  const {
    data = [],
    mutate,
    size,
    setSize,
    isValidating,
    isLoading,
    error,
  } = swr;

  const items = data ? [].concat(...data) : [];
  const container = useRef(null);

  const isLoadingMore =
    size > 0 && data && typeof data[size - 1] === "undefined";
  const isEmpty = data?.[0]?.length === 0;
  const isReachingEnd =
    isEmpty || (data && data[data.length - 1]?.length < PAGE_SIZE);
  const isRefreshing = isValidating && data?.length === size;

  if (error) return <div>데이터를 불러올 수 없습니다.</div>;
  if (!items) return <NoData />;

  return (
    <>
      <Box ref={container} sx={{ position: "relative" }}>
        {items.map((item, index) => (
          <Box key={index}>{children(item, index)}</Box>
        ))}
      </Box>
      <Stack alignItems="center" justifyContent="center" sx={{ py: 3 }}>
        {isLoadingMore ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress />
          </Box>
        ) : isReachingEnd ? (
          <NoData />
        ) : (
          <Button
            variant="outlined"
            onClick={() => setSize(size + 1)}
            sx={{
              py: 1.3,
              px: 3,
              fontSize: 12,
              minHeight: 0,
              borderRadius: 10,
              borderColor: "grey.400",
              alignItems: "center",
              color: "grey.middle",
              lineHeight: 1,
              "&:hover": {
                borderColor: "grey.400",
              },
            }}
          >
            load more
          </Button>
        )}
      </Stack>
    </>
  );
}
